import React from 'react';
import RevealMixin from './../reveal_mixin';
import CustomStylesMixin from './../custom_styles_mixin';

import createReactClass from 'create-react-class';
export default createReactClass({
  mixins: [RevealMixin, CustomStylesMixin],

  render: function() {
    return (
      <div>
        <div className="sign-container">
          <div
            className="nob"
            style={this.mergeStyles(
              this.borderColor(this.props.sign_frame_color),
              this.background_color(this.props.background_color),
            )}
          ></div>
          <div
            className="post left"
            style={this.background_color(this.props.sign_frame_color)}
          ></div>
          <div
            className="post right"
            style={this.background_color(this.props.sign_frame_color)}
          ></div>
          <div
            className="pane"
            style={this.mergeStyles(
              this.borderColor(this.props.sign_frame_color),
              this.background_color(this.props.sign_background_color),
            )}
          >
            <div
              className="headline"
              style={this.color(this.props.sign_text_color)}
            >
              404
            </div>
            <div
              className="context"
              style={this.color(this.props.sign_text_color)}
            >
              Oops, the page you're <br />
              looking for does not exist.
            </div>
          </div>
        </div>
        <div className="text-container">
          <div className="headline" style={this.secondary_text_color()}>
            404
          </div>
          <div className="context" style={this.primary_text_color()}>
            <p>
              You may want to head back to the homepage. <br />
              If you think something is broken, report a problem.
            </p>
          </div>
          <div className="buttons-container">
            <a
              href={this.href(this.props.homepage_url)}
              style={this.borderButton()}
              target="_blank"
            >
              <span className="fa fa-home"></span>
              Home page
            </a>
            <a
              href={this.support_email_address()}
              style={this.borderButton()}
              target="_blank"
            >
              <span className="fa fa-warning"></span>
              Report problem
            </a>
          </div>
        </div>
      </div>
    );
  },
});
